<template>
    <div class="press-page">
        <h1>La presse en parle</h1>
        <flickity-box class="flickity" ref="flickity_1" :options="flickityOptions">
            <div class="carousel-cell">
                <img src="../assets/press0.png" />
                <div class="desc">
                    La presse en parle : cliquez sur les liens pour faire apparaître les articles de presse correspondants.
                </div>
            </div>
            <div class="carousel-cell">
                <img src="../assets/press1.png" />
                <div class="desc">
                    <a href="static/pdf/presse/figaro-golf-nov2012.pdf" target="_blank">Magazine Le Figaro Golf</a>
                    <br />16 novembre 2012
                </div>
            </div>
            <div class="carousel-cell">
                <img src="../assets/press2.png" />
                <div class="desc">
                    <a href="static/pdf/presse/lofficiel-mai2012.pdf" target="_blank">Magazine L'Officiel</a>
                    <br />19 janvier 2012
                </div>
            </div>
            <div class="carousel-cell">
                <img src="../assets/press3.png" />
                <div class="desc">
                    <a href="static/pdf/presse/le-point_janvier2012.pdf" target="_blank">Le Point</a>
                    <br />19 janvier 2012
                </div>
            </div>
            <div class="carousel-cell">
                <img src="../assets/press4.png" />
                <div class="desc">
                    <a href="static/pdf/presse/golf-magazine_janvier2012.pdf" target="_blank">Golf Magazine</a>
                    <br />Janvier 2012
                </div>
            </div>
            <div class="carousel-cell">
                <img src="../assets/press5.png" />
                <div class="desc">
                    <a href="static/pdf/presse/golf-europeen_janvier2012.pdf" target="_blank">Magazine Golf Européen</a>
                    <br />Janvier 2012
                </div>
            </div>
            <div class="carousel-cell">
                <img src="../assets/press6.png" />
                <div class="desc">
                    <a href="static/pdf/presse/gants-golf-europeen.pdf" target="_blank">Magazine Golf Européen</a>
                    <br />Décembre 2011
                </div>
            </div>
            <div class="carousel-cell">
                <img src="../assets/press7.png" />
                <div class="desc">
                    <a href="static/pdf/presse/journal-du-golf-ok.pdf" target="_blank">Magazine Le journal du Golf</a>
                    <br />Décembre 2011
                </div>
            </div>
            <div class="carousel-cell">
                <img src="../assets/press8.png" />
                <div class="desc">
                    Site Golfamily.com
                    <br />Décembre 2011
                </div>
            </div>
            <div class="carousel-cell">
                <img src="../assets/press9.png" />
                <div class="desc">
                    <a href="static/pdf/presse/article-lemonde.pdf" target="_blank">Site lemonde.fr</a>
                    <br />20 octobre 2011
                </div>
            </div>
            <div class="carousel-cell">
                <img src="../assets/press10.png" />
                <div class="desc">
                    <a href="static/pdf/presse/fairways-site.pdf" target="_blank">Site fairways-mag.com</a>
                    <br />Octobre 2011
                </div>
            </div>
            <div class="carousel-cell">
                <img src="../assets/press11.png" />
                <div class="desc">
                    <a href="static/pdf/presse/fairways-article.pdf" target="_blank">Magazine Fairways</a>
                    <br />Septembre 2011
                </div>
            </div>
            <div class="carousel-cell">
                <img src="../assets/press_youtube.png" />
                <div class="desc">
                    <h2>Petite aparté musicale ...</h2>
                    <a href="https://www.youtube.com/watch?v=OC7ne9Xphwc&feature=socblog_th" target="_blank">Accéder à la vidéo Youtube</a>
                </div>
            </div>
        </flickity-box>
    </div>
</template>

<script>
  import FlickityBox from './FlickityBox';

  export default {
    components: {
      FlickityBox,
    },
    name: 'press-page',
    data() {
      return {
        flickityOptions: {
          imagesLoaded: true,
          contains: true,
          adaptiveHeight: false,
          wrapAround: true,
          cellAlign: 'left',

        },
      };
    },
  };
</script>
<style lang="scss">
    .press-page {
        h1 {margin-bottom:2rem;}

        .carousel-cell {
            display: block !important;

            .desc {
                display: block;
                text-align: center;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/PressPage.vue